import { Box, styled } from '@mui/material'

export const LogoContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '65px',
  position: 'relative',
  ' img': {
    objectPosition: 'center',
  },
  [theme.breakpoints.up('md')]: {
    height: '80px',
    ' img': {
      objectPosition: 'left',
    },
  },
}))
